<style lang="scss">
$leftWidth: 220px;
.goods-check-page {
  .el-form-item__content, .el-form-item__label {
    line-height: 24px !important;
  }

  .el-form-item__label {
    line-height: 24px !important;
  }

  .content-part {
    .el-form-item {
      margin-bottom: 0px;

      &__label {
        line-height: 24px;
      }
    }

    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }
}

.goods-check-page {
  .content-part {
    /* 谷歌 */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }

    /* 火狐 */
    input {
      -moz-appearance: textfield;
    }
  }
}
</style>
<template>
  <div class="goods-check-page">
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>{{ checkTable ? '编辑资源码' : '查看' }}</h3>
        <div class="hide-content show-content" v-if="form">
          <el-form ref="form" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item style="line-height: 24px !important;" label="货品名称" prop="goodsName">
              {{ form.productName }}
            </el-form-item>
            <el-form-item label="所属单位" prop="orgId" v-show="platform">
              {{ form.orgName }}
            </el-form-item>
            <el-form-item label="产品编码" prop="productCode">
              {{ form.productCode }}
            </el-form-item>
            <el-form-item label="子类编码" prop="productSubclassCode">
              {{ form.productSubclassCode }}
            </el-form-item>
            <el-form-item label="药品明细分类" prop="physicDetailType" v-show="form.physicDetailType">
              {{ formatPhysicDetailType(form.physicDetailType) }}
            </el-form-item>
            <el-form-item label="剂型" prop="productDosage">
              {{ form.productDosage }}
            </el-form-item>
            <el-form-item label="剂型规格" prop="productSpecification">
              {{ form.productSpecification }}
            </el-form-item>
            <el-form-item label="包装规格" prop="productPackingSpecification">
              {{ form.productPackingSpecification }}
            </el-form-item>
            <el-form-item label="包装单位" prop="productPackingUnit">
              {{ form.productPackingUnit || '暂无' }}
            </el-form-item>
            <el-form-item label="备注" prop="productRemark">
              {{ form.productRemark || '暂无' }}
            </el-form-item>
          </el-form>
        </div>
        <div v-if="checkTable">
          <el-table :data="tabledatas" border>
            <el-table-column :label="titleList[0].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.resourceCode"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.resourceCode }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[1].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.packingLevel"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packingLevel }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[2].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.packingCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packingCount }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[3].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.packingUnit"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packingUnit }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[4].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.packageRatio"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.packageRatio }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[5].label">
              <template slot-scope="scope">
                <el-input placeholder="" v-show="scope.row.show" type="number" :min="1"
                          v-model.trim.number="scope.row.codeVersion"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.codeVersion }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[6].label">
              <template slot-scope="scope">
                <el-input :disabled="true" placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.maxCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.maxCount }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="titleList[7].label">
              <template slot-scope="scope">
                <el-input :disabled="true" placeholder="" v-show="scope.row.show"
                          v-model.trim="scope.row.currentCount"></el-input>
                <span v-show="!scope.row.show">{{ scope.row.currentCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="140">
              <template slot-scope="scope">
                <el-button :loading="doing" v-if="!scope.row.show" @click="handleTableEdit(scope)">编辑</el-button>
                <el-button :loading="doing" v-if="!scope.row.show" @click="handleTableDelete(scope)">删除</el-button>
                <el-button :loading="doing" v-else @click="handleTableSave(scope)">保存</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button @click="handleTableAdd">新增</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http, goodsManage, resourceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import platform from "@/components/goods/platform";

export default {
  props: {
    defaultIndex: Number,
    title: String,
    platform: {
      type: Boolean,
      default: false
    },
    form: Object,
    checkTable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [methodsMixin],
  data() {
    return {
      tabledatas: [
        {
          resourceCode: '',
          packingLevel: '',
          packingCount: '',
          packingUnit: '',
          packageRatio: '',
          codeVersion: '',
          maxCount: '999999999',
          currentCount: '0',
          show: true
        }
      ],
      titleList: [
        {label: '资源编码', value: 'resourceCode'},
        {label: '包装层级', value: 'packingLevel'},
        {label: '层级件数', value: 'packingCount'},
        {label: '包装单位', value: 'packingUnit'},
        {label: '包装比例', value: 'packageRatio'},
        {label: '追溯码版本号', value: 'codeVersion'},
        {label: '最大允许申请数量', value: 'maxCount'},
        {label: '当前已经申请数量', value: 'currentCount'},
      ],
      orgRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      platformRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        orgId: {required: true, message: '请选择所属单位', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      // rules: {
      //   goodsId: {required: true, message: '请选择货品', trigger: 'change'},
      //   // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
      //   productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
      //   productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
      //   productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
      //   productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
      //   productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
      // },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    currentGoods() {
      return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    },
    rules() {
      return this.platform ? this.platformRules : this.orgRules
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
    form: {
      handler(val, oldVal) {
        if (!val) return;
        if (!val.productSubclassId) return;
        if (!this.checkTable) return;
        if (oldVal && oldVal.productSubclassId && val.productSubclassId === oldVal.productSubclassId) return;
        resourceCode.queryCode({productSubclassId: val.productSubclassId}).then(res => {
          let newData = JSON.parse(JSON.stringify(res.data));
          newData.map(m => {
            m.show = false
          })
          this.tabledatas = [
            ...newData,
            {
              resourceCode: '',
              packingLevel: '',
              packingCount: '',
              packingUnit: '',
              packageRatio: '',
              codeVersion: '',
              maxCount: '999999999',
              currentCount: '0',
              show: true
            }
          ]
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
        })
      }, immediate: true, deep: true
    }
  },
  methods: {
    formatPhysicDetailType(val) {
      let physicDetailType = this.$store.state.physicDetailType;
      return physicDetailType[val - 1] && physicDetailType[val - 1].label || val;
    },
    resetTable() {
      this.tabledatas = [
        {
          resourceCode: '',
          packingLevel: '',
          packingCount: '',
          packingUnit: '',
          packageRatio: '',
          codeVersion: '',
          maxCount: '999999999',
          currentCount: '0',
          show: true
        }
      ]
    },
    handleTableSave(scope) {
      // 当前行判空提醒
      let empty = false;
      for (let key in scope.row) {
        if (scope.row[key] === '') {
          this.$notify.error({
            duration: 2000,
            message: `${this.titleList.find(f => f.value === key).label}不能为空`
          });
          empty = true
          break;
        }
      }
      if (empty) return;


      let resourceCodeReg = /^[0-9]*$/;
      let resourceCodeRe = new RegExp(resourceCodeReg);
      if (!resourceCodeRe.test(scope.row.resourceCode)) return this.$notify.error({
        duration: 2000,
        message: `资源编码需为长度为5位的数字`
      });


      if (scope.row.resourceCode.toString().length !== 5) {
        return this.$notify.error({
          duration: 2000,
          message: `资源编码的长度应为5位`
        });
      }


      let spliceData = JSON.parse(JSON.stringify(this.tabledatas));
      spliceData.splice(scope.$index, 1)
      let newData = spliceData.sort((a, b) => {
        return b.packingLevel - a.packingLevel
      });
      //  根据住宿码版本以及包装比例分隔资源码信息

      let versionList = [];
      newData.map(m => {
        if (!versionList.find(f => f.version === m.codeVersion)) {
          versionList.push({version: m.codeVersion, ratio: []})
        }
      })

      versionList.map(m => {
        (newData.filter(f => {
          return f.codeVersion === m.version
        })).map(m2 => {
          if (!m.ratio.find(f => f === m2.packageRatio)) {
            m.ratio.push(m2.packageRatio)
          }
        })
      })

      let packageRatioGroup = []

      versionList.map((m, i) => {
        m.ratio.map((m2, i2) => {
          packageRatioGroup.push({
            version: m.version,
            ratio: m2,
            group: newData.filter(f => {
              return f.codeVersion === m.version && f.packageRatio === m2
            }).sort((a, b) => {
              return b.packingLevel - a.packingLevel
            })
          })
        })
      })


      if (packageRatioGroup.find(f => f.version.toString() === scope.row.codeVersion.toString() && f.ratio === scope.row.packageRatio)
          && packageRatioGroup.find(f => f.version.toString() === scope.row.codeVersion.toString() && f.ratio === scope.row.packageRatio).group.find(f => f.packingLevel.toString() === scope.row.packingLevel.toString() && f.resourceCode.toString() === scope.row.resourceCode.toString())) {
        return this.$notify.error({message: '相同资源码、相同版本、相同包装比例下的包装层级不能重复'});
      }
      this.doing = true;
      let params = {
        resourceCode: scope.row.resourceCode,
        packingLevel: scope.row.packingLevel,
        packingCount: scope.row.packingCount,
        packingUnit: scope.row.packingUnit,
        packageRatio: scope.row.packageRatio,
        codeVersion: scope.row.codeVersion,
        maxCount: scope.row.maxCount,
        currentCount: scope.row.currentCount,
        productSubclassId: this.form.productSubclassId
      }
      // 存在资源码ID 则添加到参数中
      if (scope.row.resourceCodeId) params.resourceCodeId = scope.row.resourceCodeId;
      if (!scope.row.resourceCodeId) {
        // 不存在资源码ID 走新增
        resourceCode.addCode(params).then(res => {
          scope.row.resourceCodeId = res.data.resourceCodeId;
          this.doing = false;
          this.$notify.success({message: '保存成功'});
          this.$emit('refreshProductRatio');
          scope.row.show = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
          this.doing = false;
        })
      } else {
        // 存在资源码ID 走编辑
        resourceCode.editCode(params).then(res => {
          this.doing = false;
          this.$notify.success({message: '保存成功'});
          this.$emit('refreshProductRatio');
          scope.row.show = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
          this.doing = false;
        })
      }
    },
    handleTableAdd() {
      // this.tabledatas.map(m => {
      //   m.show = false;
      // })
      this.tabledatas.push(
          {
            resourceCode: '',
            packingLevel: '',
            packingCount: '',
            packingUnit: '',
            packageRatio: '',
            codeVersion: '',
            maxCount: '999999999',
            currentCount: '0',
            show: true
          }
      )
    },
    handleTableDelete(scope) {
      this.doing = true;
      resourceCode.deleteCode(scope.row.resourceCodeId).then(res => {
        this.tabledatas.splice(scope.$index, 1);
        this.doing = false;
        this.$notify.success({message: '删除成功'});
      }).catch(e => {
        this.$notify.error({
          duration: 2000,
          message: this.$errHandler(e)
        });
        this.doing = false;
      })
    },
    handleTableEdit(scope) {
      this.tabledatas[scope.$index].show = true;
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    goodsChange(val) {
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        this.doing = true;
        if (!this.platform) {
          this.form.orgId = this.$store.state.user.userCompanyAddress;
        }
        if (this.title === '新增') {
          goodsManage.goodsAdd(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        } else {
          goodsManage.goodsEdit(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        }
      });
    }
  }
};
</script>
